import { Link } from 'react-router-dom';
import { AlertHistoryList } from '@/components/alerts/AlertHistoryList';

export function AlertHistoryPage() {
  return (
    <div className="space-y-6">
      <div>
        <Link
          to="/alerts"
          className="inline-flex items-center text-sm text-gray-500 hover:text-gray-700 mb-4"
        >
          <svg className="w-4 h-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Alert Rules
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Alert History</h1>
        <p className="text-sm text-gray-500 mt-1">
          View all triggered alerts
        </p>
      </div>

      <AlertHistoryList />
    </div>
  );
}
